import iocCodeSchema from '@data/schemas/iocCode'
import isoCountryCodeSchema from '@data/schemas/isoCountryCode'
import { ObjectSchema, object, string } from 'yup'

/**
 * Scham for the `country` object that is found within `TLocation`
 */
const schema: ObjectSchema<TLocation['country'], TLocation['country']> = object<TLocation['country']>()
    .shape({
        id: iocCodeSchema.required().strict(),
        name: string().required().strict(),
        iocCode: iocCodeSchema.required().strict(),
        isoCode: isoCountryCodeSchema.required().strict(),
    })
    .noUnknown()
    .from('iocCode', 'id', true)

export default schema
